module.exports = __webpack_public_path__ + "static/media/fte-sweat-workout-thumbnail.29f5e79e.png";